module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jINkY"))).then(() => parcelRequire('d0iPb'));